import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";

export interface ICenterFormMeta {
    myId: FormInputMeta;
    name: FormInputMeta;
    initials: FormInputMeta;
    license: FormInputMeta;
    siretNumber: FormInputMeta;
    socialSecurityNumber: FormInputMeta;
    capital: FormInputMeta;
    commercialRegistrationNumber: FormInputMeta;
    fiscalIdentificationNumber: FormInputMeta;
    hour: FormInputMeta;
    gmt: FormInputMeta;
    schema: any;
  }

const CenterFormMeta = {} as ICenterFormMeta;

CenterFormMeta.myId = {
    name: "myId",
    label: "ID",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.name = {
    name: "name",
    label: "Nom",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.initials = {
    name: "initials",
    label: "Initiales",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.license = {
    name: "license",
    label: "Licence",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.siretNumber = {
    name: "siretNumber",
    label: "Numéro Siret",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.socialSecurityNumber = {
    name: "socialSecurityNumber",
    label: "Numéro Sécurité Sociale",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.capital = {
    name: "capital",
    label: "Capital",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.commercialRegistrationNumber = {
    name: "commercialRegistrationNumber",
    label: "Numéro Registre Commerce",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.fiscalIdentificationNumber = {
    name: "fiscalIdentificationNumber",
    label: "Numéro Identification Fiscale",
    type: "text",
    validation: yup.string().required("This field is required"),
}
CenterFormMeta.hour = {
    label: 'Heure',
    name: 'hour',
    type: 'select',
    placeholder: 'Select ...',
    options:  [
      {
        label: '1',
        value: '1'
      },
      {
        label: '2',
        value: '2',
      },
      {
        label: '3',
        value: '3',
      },
    ],
    validation: yup.string().required(),
  }
  CenterFormMeta.gmt = {
    name: "gmt",
    label: "GMT",
    type: "text",
    validation: yup.string().required("This field is required"),
}




CenterFormMeta.schema = yup.object().shape(getValidationSchema(CenterFormMeta));

export default CenterFormMeta;